import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box, Text } from "braid-design-system";
import { translations } from "./.vocab/index.mjs";
const TaxSuffix = ({
  children,
  taxCode,
  displayRecommendation,
  flexDirection = "row"
}) => {
  const { t } = useTranslations(translations);
  const suffix = `${displayRecommendation === "inclusive" ? `${t("incl.")} ` : "+ "}${taxCode}`;
  const isFlexDirectionRow = flexDirection === "row";
  return /* @__PURE__ */ jsxs(
    Box,
    {
      display: "flex",
      flexDirection,
      alignItems: isFlexDirectionRow ? "flexEnd" : "flexStart",
      data: { testid: "taxSuffix" },
      children: [
        children,
        /* @__PURE__ */ jsx(Box, { marginTop: isFlexDirectionRow ? "none" : "xsmall", children: /* @__PURE__ */ jsxs(Text, { size: "standard", tone: "secondary", children: [
          isFlexDirectionRow ? /* @__PURE__ */ jsx("span", { children: " " }) : null,
          suffix
        ] }) })
      ]
    }
  );
};
export {
  TaxSuffix
};
